import * as React from "react";
import SignaturePad from "signature_pad";
import { IField } from "./MomoForm";

interface ISignaturePadProps{
    item        : IField
    onChange    : IOnChange
}

interface IOnChange{
    (id:string, value:string):void
}

type IMode = 'upload' | 'signature';

interface ISignaturePadState{
    mode              : IMode
    value             : string
    showSuccessMessage: boolean
}
export default class SignaturePadComp extends React.Component<ISignaturePadProps, ISignaturePadState>{

    private signaturePads:any;
    private canvas:HTMLCanvasElement = null;

    constructor(props: ISignaturePadProps) {
        super(props);
        this.state = {
            mode              : 'upload',
            value             : '',
            showSuccessMessage:  false
        };
    }

    componentDidMount() {
        this.events();
    }

    componentDidUpdate(){
        this.events();
    }

    private resizeCanvas() {
        var ratio               = Math.max(window.devicePixelRatio || 1, 1);
        this.canvas.width       = this.canvas.offsetWidth * ratio;
        this.canvas.height      = this.canvas.offsetHeight * ratio;
        this.canvas.getContext("2d").scale(ratio, ratio);
    }

    private setSignature(val:string, showSuccessMessage:boolean):void{
        this.setState({
            value             : val,
            showSuccessMessage: showSuccessMessage
        }, () => {
            this.props.onChange('file_'+this.props.item.id, val);
        });
    }

    private saveClickHandler(evt: React.MouseEvent<HTMLButtonElement, MouseEvent>): void {
        evt.preventDefault();
        let id = this.props.item.id;
        if ( this.signaturePads.isEmpty() ) {
            this.setSignature('', false);
            return alert("Please provide a signature first.");
        }
        var data = this.signaturePads.toDataURL('image/jpeg');
        this.setSignature(data, true);
    }

    private clearClickHandler(evt: React.MouseEvent<HTMLButtonElement, MouseEvent>): void {
        evt.preventDefault();
        this.signaturePads.clear();
        this.setSignature('', true);
    }

    private undoClickHandler(evt: React.MouseEvent<HTMLButtonElement, MouseEvent>): void {
        evt.preventDefault();
        var data = this.signaturePads.toData();
        if (data) {
            data.pop(); // remove the last dot or line
            this.signaturePads.fromData(data);
            this.setState({
                showSuccessMessage: false
            });
        }
    }


    private events(){
        if ( this.canvas !== null ) {
            return; // reinit block
        }
        this.canvas = document.getElementById("signature-pad_" + this.props.item.id) as any;
        if ( this.canvas !== null ) {
            this.resizeCanvas();
            this.signaturePads = new SignaturePad(this.canvas, {
                backgroundColor: 'rgb(255, 255, 255)'
            });

            window.addEventListener('resize', () => {
                this.resizeCanvas();
            });
        }
    }

    private changeInputHandler(evt: React.ChangeEvent<HTMLInputElement>): void {
        evt.preventDefault();
        let id   = this.props.item.id;
        this.props.onChange(id, evt.target.value);
    }

    private changeModeHandler(evt: React.MouseEvent<HTMLButtonElement>, value: IMode): void {
        evt.preventDefault();
        this.setState({
            mode: value
        }, ()=>{
            if ( value === 'upload') {
                this.props.onChange('file_'+this.props.item.id, '');
            }else{
                this.props.onChange(this.props.item.id, '');
            }
        });
    }

    render() {
        let item = this.props.item;
        return (
            <>
                <div className="btn-group" role="group" style={{marginLeft: '10px', marginBottom: '10px'}}>
                    <button type="button" className={"btn btn-light" + (this.state.mode==='upload'?' active':'')} onClick={(e) => this.changeModeHandler(e, 'upload')}>Fájl feltöltés</button>
                    <button type="button" className={"btn btn-light"+ (this.state.mode==='signature'?' active':'')} onClick={(e) => this.changeModeHandler(e, 'signature')}>Aláírás</button>
                </div>
                <br />
                { this.state.mode === 'upload'?<>
                    <input
                        type="file"
                        defaultValue={ item.value }
                        multiple={true}
                        id={ item.id }
                        className={ item.className }
                        placeholder={ item.placeholder }
                        required={ item.required }
                        readOnly={ item.readOnly }
                        onChange={ (e) => this.changeInputHandler(e) }
                    />
                </>:<div className="signature_modal_body show_signature" id={'show_signature_' + this.props.item.id}>
                    <div className="card">
                        <div className="card-header">Aláírás</div>
                        <div className="card-body">
                            <div className="state">
                                <canvas id={"signature-pad_" + this.props.item.id} className="signature-pad" width={400} height={200}></canvas>
                                <input type="text" className="base64_file_name" required={ item.required } name={'file_'+item.id+'[]'} defaultValue={this.state.value} />
                            </div>
                        </div>
                        <div className="card-footer">
                            {this.state.showSuccessMessage===true?<div className="alert alert-success">Sikeres módosítás!</div>:''}
                            <button type="button" className="btn btn-default btn-success signature_save_btn" style={{ marginRight: '10px' }} onClick={e => this.saveClickHandler(e)}>Mentés</button>
                            <button type="button" className="btn btn-default btn-warning signature_undo_btn" style={{ marginRight: '10px' }} onClick={e => this.undoClickHandler(e)}>Visszavonás</button>
                            <button type="button" className="btn btn-default btn-danger signature_clear_btn" onClick={e => this.clearClickHandler(e)}>Törlés</button>
                        </div>
                    </div>
                </div> }
            </>
        );
    }
}
